import { useMemo } from 'react';
import { Product } from '@mews-commander/data-access';
import { Optional } from '@mews/std';

interface UseProductsByServiceIdParams {
    products: Optional<Product[]>;
    serviceId: string | undefined;
}

export const useProductsByServiceId = ({ serviceId, products }: UseProductsByServiceIdParams) =>
    useMemo(
        () => ({
            products: products?.filter((product) => product.serviceId === serviceId),
        }),
        [serviceId, products]
    );
